import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetOperadora } from '@/shared/actions/erp';
import { SaveOperadoraComponent } from '../../shared/components/SaveOperadoraComponent';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateOperadoraPageProps { }

const UpdateOperadoraPage: React.FC<UpdateOperadoraPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_operadora);
  const returnUrlOperadoraPage = ROUTER_PATHS.configuracionRED.operadoraNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOperadora(id!);

  if (isLoading || isRefetching) return null;

  if (!data?.data?.id_operadora)
    return <Navigate to={returnUrlOperadoraPage} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveOperadoraComponent title="Editar Operadora" operadora={data.data} />;
};

export default UpdateOperadoraPage;
